module.exports = __webpack_public_path__ + "img/8.37dcd729.png";